import React, { useEffect, useRef, useState } from 'react';
import { reel } from '../data/videoData';

// 转盘式片头：只有正中间那条在播，两侧的暂停并显示首帧，离中心越远越小越淡。
// 用 transform 排布而不是滚动容器，这样"第几个在中间"是一个明确的 state，
// 播放/暂停就能跟着它走，不用去猜滚动位置。
export default function ResearchReel() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const videos = useRef([]);

  // 只让当前这条播；其余一律暂停并回到第一帧
  useEffect(() => {
    videos.current.forEach((v, i) => {
      if (!v) return;
      if (i === active && !paused) {
        const p = v.play();
        if (p) p.catch(() => {});   // 自动播放被拦就算了，poster 还在
      } else {
        v.pause();
        if (i !== active) v.currentTime = 0;
      }
    });
  }, [active, paused]);

  const go = (d) => setActive(a => (a + d + reel.length) % reel.length);

  // 键盘左右切换，焦点在转盘上时才接管
  const onKeyDown = (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
  };

  const item = reel[active];

  return (
    <section className="reel" aria-roledescription="carousel" aria-label="Simulation clips">
      <div className="reel-stage" tabIndex={0} onKeyDown={onKeyDown}>
        {reel.map((v, i) => {
          // 相对位置取环形最短距离，这样首尾相接时不会从最左飞到最右
          let d = i - active;
          if (d > reel.length / 2) d -= reel.length;
          if (d < -reel.length / 2) d += reel.length;
          const far = Math.abs(d) > 1;
          return (
            <button
              type="button"
              key={v.id}
              className={`reel-slot${d === 0 ? ' is-active' : ''}`}
              style={{
                transform: `translateX(${d * 58}%) scale(${d === 0 ? 1 : 0.68})`,
                opacity: far ? 0 : d === 0 ? 1 : 0.4,
                zIndex: 10 - Math.abs(d),
                pointerEvents: far ? 'none' : 'auto',
              }}
              aria-label={d === 0 ? `${v.title} (playing)` : `Show ${v.title}`}
              aria-hidden={far}
              onClick={() => (d === 0 ? setPaused(p => !p) : setActive(i))}
            >
              <video
                ref={el => (videos.current[i] = el)}
                src={v.src}
                poster={v.poster}
                muted
                loop
                playsInline
                preload={Math.abs(d) <= 1 ? 'auto' : 'none'}
                tabIndex={-1}
              />
              {d === 0 && paused && <span className="reel-play">▶</span>}
            </button>
          );
        })}

        <button type="button" className="reel-nav reel-prev" onClick={() => go(-1)} aria-label="Previous clip">‹</button>
        <button type="button" className="reel-nav reel-next" onClick={() => go(1)} aria-label="Next clip">›</button>
      </div>

      <div className="reel-caption">
        {/* 标题可点，跳到右栏对应的那篇 */}
        {item.to ? (
          <h3>
            <a
              href={`#${item.to}`}
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(item.to)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >{item.title}</a>
          </h3>
        ) : <h3>{item.title}</h3>}
        <p>{item.caption}</p>
        <div className="reel-dots" role="tablist">
          {reel.map((v, i) => (
            <button
              type="button"
              key={v.id}
              role="tab"
              aria-selected={i === active}
              aria-label={v.title}
              className={`reel-dot${i === active ? ' is-active' : ''}`}
              onClick={() => setActive(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
